import { IActualizarContrasenia } from "../Interfaces/IUsuario";
import { Ifilter } from "../Interfaces/filter";
import { fetchIdentidad } from "./http-common";
import tokenService from "./tokenService";

const versionApi = "v1";
const allUsuario = (filter: Ifilter) => {
  return fetchIdentidad.get(`${versionApi}/User`, {
    headers: { Authorization: `Bearer ${tokenService.getToken()}` },
    params: filter,
  });
};
const actualizarContraseniaUsario = (data: IActualizarContrasenia) => {
  return fetchIdentidad.put(`${versionApi}/User/CambiarContrasenia`, data);
};

const ConfiguracionesService = {
  allUsuario,
  actualizarContraseniaUsario,
};

export default ConfiguracionesService;
